import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Audit, Finding } from '../../audit.model';
import { BreadcrumbItem } from '../../../shared/shared.model';
import { FindingService } from '../../finding.service';
import { BehaviorSubject } from 'rxjs';
import { FindingEditFormComponent } from '../finding-edit-form/finding-edit-form.component';

@Component({
  selector: 'iaud-finding-add',
  templateUrl: './finding-add.component.html',
  styleUrls: ['./finding-add.component.scss']
})
export class FindingAddComponent implements OnInit {

  auditId: number = 0;
  audit: Audit;
  isFormValid: boolean = false;
  isFinishLaterValid: boolean = false;
  isNextLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isLaterLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @ViewChild('editFormComponent') editFormComponent: FindingEditFormComponent;

  finding: Finding = {
    status: 'draft',
  };

  breadcrumbs: Array<BreadcrumbItem> = [
    {
      title: 'Home',
      path: '/home',
    },
    {
      title: 'All audits',
      path: '/audit',
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private findingService: FindingService
  ) { }

  ngOnInit(): void {
    this.auditId = +this.route.snapshot.params.id;
    this.finding.auditId = this.auditId;
    this.audit = this.route.snapshot.data.audit;
    this.breadcrumbs.push({
      title: `Audit: ${this.audit.auditTitle || '[no title]'}`,
      path: `/audit/${this.audit.id}`,
    });
    this.breadcrumbs.push({
      title: 'Add Finding',
      path: '',
    });
  }
  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }
  toggleFinishLaterFormValidity(valid: boolean): void {
    this.isFinishLaterValid = valid;
  }
  submitFinding(later: boolean): void {
    if (!this.isFinishLaterValid) {
      
      this.editFormComponent.findingForm.get('title').markAsTouched();
      this.editFormComponent.findingForm.get('dueDate').markAsTouched();

      return;
    }
    this.findingService.submitFinding(this.finding)
      .subscribe(value => {       

        if (later)
          return this.router.navigateByUrl(`/audit/${this.auditId}`);
        else          
          return this.router.navigateByUrl(`/audit/${this.auditId}/finding/${value}/capa/add`);        
      
      });
  }
}